export default __webpack_public_path__ + "static/media/start.a934b940.svg";